import React from 'react';
import { Star, Shield, Lock, Eye, Award } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function SocialProof() {
  const badges = [{
    text: 'Verified',
    icon: <Shield className="w-4 h-4 mr-1.5" data-id="element-76" />
  }, {
    text: 'Trusted',
    icon: <Award className="w-4 h-4 mr-1.5" data-id="element-77" />
  }, {
    text: 'Secure',
    icon: <Lock className="w-4 h-4 mr-1.5" data-id="element-78" />
  }, {
    text: 'BBB A+',
    icon: <Eye className="w-4 h-4 mr-1.5" data-id="element-79" />
  }];
  const testimonials = [{
    quote: 'Saved $2,400 on my window installation. The process was incredibly fast and easy.',
    name: 'Sarah M.',
    location: 'Austin, TX'
  }, {
    quote: 'I had no idea I was about to overpay by so much. Getting 3 quotes saved me thousands.',
    name: 'David R.',
    location: 'Denver, CO'
  }, {
    quote: 'Highly recommend! Found a great local company and the price was exactly what I wanted.',
    name: 'Emily T.',
    location: 'Orlando, FL'
  }];
  return <section className="py-16 px-4 max-w-6xl mx-auto text-center" data-id="element-80">
      <FadeIn data-id="element-81">
        <div className="flex flex-col items-center justify-center mb-8" data-id="element-82">
          <div className="flex space-x-1 mb-2" data-id="element-83">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 text-yellow-400 fill-yellow-400" data-id="element-84" />)}
          </div>
          <p className="text-sm font-medium text-gray-600" data-id="element-85">
            Rated 4.8/5 based on verified reviews
          </p>
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-12 leading-tight max-w-3xl mx-auto" data-id="element-86">
          Thousands of homeowners have already compared prices and paid less.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12 text-left" data-id="element-87">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-88">
              <div className="flex space-x-1 mb-4" data-id="element-89">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-90" />)}
              </div>
              <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-91">"{t.quote}"</p>
              <div data-id="element-92">
                <p className="font-bold text-gray-900" data-id="element-93">{t.name}</p>
                <p className="text-sm text-gray-500" data-id="element-94">{t.location}</p>
              </div>
            </div>)}
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-6" data-id="element-95">
          {badges.map((badge, index) => <div key={index} className="flex items-center px-4 py-2 bg-gray-50 rounded-full text-gray-600 font-semibold text-xs sm:text-sm tracking-wide uppercase border border-gray-100" data-id="element-96">
              {badge.icon}
              {badge.text}
            </div>)}
        </div>
      </FadeIn>
    </section>;
}